import { Component, Input } from '@angular/core';

import { IPatientRequestMaterial } from '@app/core/patient-requests';

@Component({
  selector: 'afoone-request-materials',
  templateUrl: './request-materials.component.html',
  styleUrls: ['./request-materials.component.css']
})
export class RequestMaterialsComponent {

  @Input()
  public materials: IPatientRequestMaterial[];

}
